export enum ExcludeCategoryFilterKey {
    SuppressionListIds = "suppressionListIds",
    StaticListsToExclude = "staticListsToExclude",
    Salesforce = "salesforce",
    Hubspot = "hubspot",
}
